const TOKEN_RE =
  /(-?)(?:(from|sender|has|before|after|is|tag):([^\s"]+|"[^"]*")|"([^"]+)"|(\S+))/gi;

function unquote(s) {
  if (!s) return s;
  if (
    (s.startsWith('"') && s.endsWith('"')) ||
    (s.startsWith("'") && s.endsWith("'"))
  ) {
    return s.slice(1, -1);
  }
  return s;
}

function parseDate(s) {
  if (!s) return null;
  const trimmed = unquote(s).trim();
  if (!trimmed) return null;
  if (/^today$/i.test(trimmed)) {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
  }
  if (/^yesterday$/i.test(trimmed)) {
    const d = new Date();
    d.setDate(d.getDate() - 1);
    d.setHours(0, 0, 0, 0);
    return d;
  }
  const m = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (m) {
    const d = new Date(`${m[1]}-${m[2]}-${m[3]}T00:00:00`);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const ts = Date.parse(trimmed);
  return Number.isNaN(ts) ? null : new Date(ts);
}

export function parseSearchSyntax(raw) {
  const result = {
    freeText: "",
    excludedText: [],
    from: null,
    tag: null,
    hasMedia: false,
    before: null,
    after: null,
    isFlags: new Set(),
  };
  if (!raw || typeof raw !== "string") return result;

  const freeWords = [];
  TOKEN_RE.lastIndex = 0;
  let m;
  while ((m = TOKEN_RE.exec(raw)) !== null) {
    const exclude = m[1] === "-";
    const key = m[2]?.toLowerCase();
    const val = m[3] ? unquote(m[3]) : undefined;
    const quoted = m[4];
    const bare = m[5];

    if (key && val !== undefined) {
      switch (key) {
        case "from":
        case "sender":
          result.from = val;
          break;
        case "tag":
          result.tag = val;
          break;
        case "has":
          if (/^(image|file|media|photo|video)$/i.test(val)) {
            result.hasMedia = true;
          }
          break;
        case "before": {
          const d = parseDate(val);
          if (d) result.before = d.toISOString();
          break;
        }
        case "after": {
          const d = parseDate(val);
          if (d) result.after = d.toISOString();
          break;
        }
        case "is":
          result.isFlags.add(val.toLowerCase());
          break;
        default:
          break;
      }
    } else if (quoted) {
      if (exclude) result.excludedText.push(quoted);
      else freeWords.push(quoted);
    } else if (bare) {
      if (exclude) result.excludedText.push(bare);
      else freeWords.push(bare);
    }
  }
  result.freeText = freeWords.join(" ");
  return result;
}

export default parseSearchSyntax;
